import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  showConciergeChat as showConciergeChatAction,
  showSupportChat as showSupportChatAction,
  showMyCssSupportChat as showMyCssSupportChatAction,
} from "../../reducers/global/GlobalActions";
import { sendContactConcierge } from "../../utils/TagManagerHelper";

function AskConciergeChatTrigger({
  className,
  children,
  showConciergeChat,
  showSupportChat,
  showMyCssSupportChat,
  isSupport,
  isMyCssSupport,
  onClick,
}) {
  const handleClick = () => {
    if (isSupport) {
      onClick();
      sendContactConcierge();
      showSupportChat();
    } else if (isMyCssSupport) {
      onClick();
      sendContactConcierge();
      showMyCssSupportChat();
    } else {
      showConciergeChat();
    }
  };

  return (
    <button tabIndex={0} onClick={handleClick} className={className} type="button">
      {children}
    </button>
  );
}

AskConciergeChatTrigger.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showConciergeChat: PropTypes.func.isRequired,
  showSupportChat: PropTypes.func.isRequired,
  showMyCssSupportChat: PropTypes.func.isRequired,
  isSupport: PropTypes.bool,
  isMyCssSupport: PropTypes.bool,
  onClick: PropTypes.func,
};

AskConciergeChatTrigger.defaultProps = {
  isSupport: false,
  isMyCssSupport: false,
  onClick: () => {},
};

const mapDispatchToProps = (dispatch) => ({
  showConciergeChat: () => dispatch(showConciergeChatAction()),
  showSupportChat: () => dispatch(showSupportChatAction()),
  showMyCssSupportChat: () => dispatch(showMyCssSupportChatAction()),
});

export default connect(null, mapDispatchToProps)(AskConciergeChatTrigger);
